import { render, staticRenderFns } from "./ReceiveChannelChart.vue?vue&type=template&id=6607c52b"
import script from "./ReceiveChannelChart.vue?vue&type=script&lang=js"
export * from "./ReceiveChannelChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports